// extracted by mini-css-extract-plugin
module.exports = {"labelHeader":"index-module__labelHeader___HBRc9","colorRequired":"index-module__colorRequired___1jtRD"};